export const screenSize = {
  tablet: 'min-width: 768px',
  desktop: 'min-width: 992px',
  largeDesktop: 'min-width: 1200px',

  maxMobile: 'max-width: 767px',
};

export const maxAppWidth = '1200px';
